import axios from "axios";
import { GET_TEMPLATES_SERVER,
  GET_CATEGORIES_DATA_SERVER,
} from "../../utils/misc";
import {
  GET_TEMPLATES,
  GET_CATEGORIES_DATA,
} from "./types";

export async function getTemplates() {
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_TEMPLATES_SERVER, { headers: headers }).then((res) => {
    let templateProperties = res.data.data;
    return {
      templateProperties
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_TEMPLATES,
    payload: request,
  };
}

export async function getCategoriesData() {
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_CATEGORIES_DATA_SERVER, { headers: headers }).then((res) => {
    let categories = res.data.data;
    return {
      categories
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_CATEGORIES_DATA,
    payload: request,
  };
}